import headerImage from "../../assets/headSection/ourClient.svg";

export const client = {
  title: "We have Worked With them",
  info: "1500+ schools are powered by Dynamic academic ERP.",
  headerImage: headerImage,
  clients: Array(22).fill(),
};
